import request from "@/utils/request";
// import {formatSourceDataFromSever} from "@/views/BCSProduct/style-xml-manager";


// /**
//  * 标题
//  * @param userId
//  * @param key
//  * @returns {AxiosPromise}
//  */
export function AnalysisTitle({userId}) {
    return request({url: `/appi/Index/AnalysisTitle?uId=${userId}`})
}



// export function getSaleAnalysisTrend({userId}) {
//     return request({url: `/appi/Index/SaleAnalysisTrend?uId=${userId}`})
// }

// export function getSaleAnalysis({userId}) {
//     return request({
//         url: `/appi/Index/SaleAnalysis?uId=${userId}`,
//     }).then(response => {
//         const {data} = response;
//         // console.log(data);      ,  ,
//         return Promise.resolve({
//             data: [[...data[0].map(item => ({
//                 xAxisName: item.jcdx,
//                 cnt: item.cnts,
//                 title:'监测类型分析'
//             }))],
//              [...data[1].map(item => ({
//                 xAxisName: item.province,
//                 cnt: item.cnts,
//                 title:'省份分布分析'
//             }))], 
//             [...data[2].map(item => ({
//                 xAxisName: item.Cate_c, 
//                 cnt: item.cnts,
//                 title:'产品分类分析'
//             }))]
//         ]
//         });
//     })
// }
